// @flow
import React, { useState } from 'react';
import injectSheet from 'react-jss';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import 'react-datepicker/dist/react-datepicker.css';
import Dropdown from './Dropdown';
import { S, DARK } from '~/app/ui/tokens';

type Date = {
  date?: string,
  timezone?: string
}

type Props = {
  value: Date,
  classes: Object,
  onChange: (Date) => void,
};

// Convert to same time in local timezone
const convertToLocal = (date, timezone) => {
  const localDate = moment(date);
  const eventDate = moment(date).tz(timezone);

  localDate.date(eventDate.date());
  localDate.hour(eventDate.hour());
  localDate.minute(eventDate.minute());

  return localDate;
};

// Convert to same time in target timezone
const convertToTimezone = (date, timezone) => {
  const localDate = moment(date);
  const eventDate = moment(date).tz(timezone);

  eventDate.date(localDate.date());
  eventDate.hour(localDate.hour());
  eventDate.minute(localDate.minute());

  return eventDate;
};

function CalendarPicker(props: Props) {
  const {
    value = {},
    onChange,
    classes
  } = props;
  const { date, timezone: defaultTZ } = value;

  const [timezone, setTimezone] = useState(defaultTZ || 'America/Los_Angeles');
  const timezoneOptions = [
    'America/Los_Angeles',
    'Asia/Shanghai'
  ];

  const updateDate = (newDate) => {
    if (!newDate) {
      onChange({});
      return;
    }

    const eventDate = convertToTimezone(newDate, timezone);

    onChange({ date: moment(eventDate).utc().format(), timezone });
  };

  return (
    <div className={classes.input}>
      <div className={classes.timezoneSelect}>
        <Dropdown
          value={timezone}
          options={timezoneOptions}
          onChange={setTimezone}
        />
      </div>
      <DatePicker
        selected={(date && convertToLocal(date, timezone).toDate()) || ''}
        showTimeSelect
        showTimeSelectOnly={date && !convertToLocal(date, timezone).hour() && !convertToLocal(date, timezone).minute()}
        timeIntervals={15}
        timeCaption="Time"
        // Selecting the time is optional
        dateFormat={date && !convertToLocal(date, timezone).hour() && !convertToLocal(date, timezone).minute() ? 'MM-dd-yyyy' : 'MM-dd-yyyy hh:mm a'}
        onChange={updateDate}
      />
    </div>
  );
}

const styles = {
  input: {
    '& input': {
      color: 'hsl(0, 0%, 20%)',
      width: '100%',
      border: '1px solid hsl(0, 0%, 90%)',
      padding: '10px 10px',
      outline: 'none',
      fontSize: '13px',
      fontWeight: '400',
      borderRadius: '3px'
    },
    [DARK]: { '& input': { color: S.fg, borderColor: S.fieldLine, background: S.field } }
  },
  timezoneSelect: {
    marginBottom: '20px'
  }
};

export default injectSheet(styles)(CalendarPicker);
